import { useCallback, useEffect, useLayoutEffect, useState } from "react";

const STORAGE_KEY = "homeViewMode";
const CHANGE_EVENT = "homeViewMode:change";

const readStoredFeedView = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(STORAGE_KEY) === "feed";
};

export const useFeedView = ({ applyClass = false } = {}) => {
  const [isFeedView, setIsFeedViewState] = useState(readStoredFeedView);

  useLayoutEffect(() => {
    if (!applyClass) return;
    const html = document.documentElement;
    const body = document.body;

    if (isFeedView) {
      html.classList.add("feed-scroll-mode");
      body.classList.add("feed-scroll-mode");
    } else {
      html.classList.remove("feed-scroll-mode");
      body.classList.remove("feed-scroll-mode");
    }

    return () => {
      html.classList.remove("feed-scroll-mode");
      body.classList.remove("feed-scroll-mode");
    };
  }, [applyClass, isFeedView]);

  useEffect(() => {
    const syncFromStorage = () => setIsFeedViewState(readStoredFeedView());
    window.addEventListener("storage", syncFromStorage);
    window.addEventListener(CHANGE_EVENT, syncFromStorage);
    return () => {
      window.removeEventListener("storage", syncFromStorage);
      window.removeEventListener(CHANGE_EVENT, syncFromStorage);
    };
  }, []);

  const setIsFeedView = useCallback((updater) => {
    setIsFeedViewState((prev) => {
      const next = typeof updater === "function" ? updater(prev) : !!updater;
      window.localStorage.setItem(STORAGE_KEY, next ? "feed" : "grid");
      window.dispatchEvent(new Event(CHANGE_EVENT));
      return next;
    });
  }, []);

  return [isFeedView, setIsFeedView];
};

export default useFeedView;
